<!-- Reusable shell for each of the 5 mechanic rows -->
<script setup>
defineProps({
    index: { type: String, required: true },
    accent: { type: String, required: true },
    eyebrow: { type: String, required: true },
    title: { type: String, required: true },
    sub: { type: String, required: true },
    kickerNew: { type: Boolean, default: false },
    footerNote: { type: String, default: '' },
    footerLabel: { type: String, default: '' },
})
</script>

<template>
    <section class="row" :style="{ '--accent': accent }">
        <header class="row__head">
            <div class="row__copy">
                <div class="row__meta">
                    <span class="row__idx" :style="{ color: accent }">{{ index }}</span>
                    <span class="row__hairline" />
                    <span class="eyebrow" :style="{ color: accent }">{{ eyebrow }}</span>
                    <span v-if="kickerNew" class="tag-new">NEW</span>
                </div>
                <h3 class="row__h3">{{ title }}</h3>
                <p class="row__sub">{{ sub }}</p>
            </div>

        </header>

        <slot />

        <div v-if="footerNote || $slots['footer-action']" class="row__foot">
            <span class="muted small">{{ footerNote }}</span>
            <slot name="footer-action" />
        </div>
    </section>
</template>

<style scoped>
.row {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.10);
    border-top: 2px solid var(--accent);
    border-radius: 24px;
    padding: 32px;
    color: #fff;
    box-shadow: 0 1px 0 rgba(255,255,255,0.04) inset;
}
.row__head {
    display: flex; align-items: flex-start; justify-content: space-between;
    gap: 32px; margin-bottom: 24px;
}
.row__copy { max-width: 620px; }
.row__meta { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
.row__idx { font-family: 'Manrope', sans-serif; font-size: 13px; font-weight: 800; letter-spacing: 0.05em; }
.row__hairline { width: 24px; height: 1px; background: rgba(255,255,255,0.10); }
.row__h3 { font-family: 'Manrope', sans-serif; font-size: 36px; font-weight: 800; letter-spacing: -0.02em; line-height: 1.05; margin: 0 0 12px; }
.row__sub { font-size: 15px; color: #eaeaea; line-height: 1.55; margin: 0; max-width: 560px; }
.row__foot {
    margin-top: 20px;
    display: flex; align-items: center; justify-content: space-between;
}
.row__cta {
    padding: 10px 16px; border-radius: 10px; text-decoration: none;
    font-size: 13px; font-weight: 700;
    background: transparent; border: 1px solid;
}
.eyebrow {
    font-weight: 700; font-size: 11px; text-transform: uppercase; letter-spacing: 0.10em;
}
.tag-new {
    font-size: 9px; font-weight: 900; letter-spacing: 0.12em;
    padding: 2px 6px; border-radius: 4px;
    background: rgba(251,191,36,0.15); color: #FCD34D;
    border: 1px solid rgba(251,191,36,0.30);
}


.muted { color: #eaeaea; }
.small { font-size: 11px; }

@media (max-width: 768px) {
    .row { padding: 20px 16px; border-radius: 16px; }
    .row__head { flex-direction: column; gap: 12px; margin-bottom: 16px; }
    .row__h3 { font-size: 24px; margin-bottom: 8px; }
    .row__sub { font-size: 14px; }
    .row__foot { flex-direction: column; align-items: flex-start; gap: 10px; }
}
</style>
